import { SidebarMenuMain } from './SidebarMenuMain'

const SidebarMenu = () => {
  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid' style={{ backgroundColor: "#FFFFFF" }}>
      <div
        id='app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper my-5'
        data-scroll='true'
        data-scroll-activate='true'
        data-scroll-height='auto'
        data-scroll-dependencies='#app_sidebar_logo, #app_sidebar_footer'
        data-scroll-wrappers='#app_sidebar_menu'
        data-scroll-offset='5px'
        data-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-sub-indention'
          id='#app_sidebar_menu'
          data-menu='true'
          data-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export { SidebarMenu }
